import { socket } from '@/user.socket'

const EMIT_TIERS = 'jackpot:tiers'
const TIERS_ON_PREFIX = 'tiers-'
const LEAVE_EVENT = 'jackpot:tiers-leave'

let boundTiersEvents = []

/**
 * @param {string[]} jackpotNames - Names of jackpots 
 */
export function joinJackpotHalls(jackpotNames) {
  if (!Array.isArray(jackpotNames)) return
  const names = jackpotNames.filter(Boolean)
  names.forEach((name) => {
    socket.emit(EMIT_TIERS, { name })
  })
}

/**
 * @param {string[]} jackpotNames - Names of jackpots to leave
 */
export function leaveJackpotHalls(jackpotNames) {
  if (!Array.isArray(jackpotNames)) return
  const names = jackpotNames.filter(Boolean)
  names.forEach((name) => {
    socket.emit(LEAVE_EVENT, { name })
  })
}

/**
 * @param {string[]} jackpotNames 
 * @param {(data: { ok?: boolean, data?: Record<string, Array<{ tier_name: string, contribution_amount: number, is_ready: boolean }>> }) => void} onTiersUpdate - Callback when tier data is received (e.g. update auth store jpTiers)
 */
export function bindJackpotTiersSocket(jackpotNames, onTiersUpdate) {
  boundTiersEvents.forEach((eventName) => socket.off(eventName))
  boundTiersEvents = []

  if (!Array.isArray(jackpotNames) || !onTiersUpdate) return

  const names = jackpotNames.filter(Boolean)
  names.forEach((name) => {
    const eventName = `${TIERS_ON_PREFIX}${name}`
    socket.on(eventName, onTiersUpdate)
    boundTiersEvents.push(eventName)
  })
}
